import {Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy} from "@angular/core";

import {FormBuilder, FormGroup} from "@angular/forms";
interface IHeaders {
	field?: string;
	label?: string;
	type?: string;
	choices?: any[];
	op?: string;
	data?: any;
}
@Component({
	selector: "app-search-select-filter",
	template: `
		<div class="field">
			<select
				*ngIf="field.field === 'complaintTypeId.complaintTypeId'"
				class="ui fluid dropdown"
				[(ngModel)]="field.data"
			>
				<option *ngFor="let opt of field.choices" [ngValue]="opt.complaintTypeId">
					{{ opt.complaintTypeName }}
				</option>
			</select>
			<select
				*ngIf="field.field === 'oldContractorUsername'"
				class="ui fluid dropdown"
				[(ngModel)]="field.data"
				(ngModelChange)="changeField($event)"
			>
				<option *ngFor="let opt of field.choices" [ngValue]="opt.optionId">
					{{ opt.optionName }} {{ opt.optionDescription }}
				</option>
			</select>
			<select
				*ngIf="field.field !== 'complaintTypeId.complaintTypeId' && field.field !== 'oldContractorUsername'"
				class="ui fluid dropdown"
				[(ngModel)]="field.data"
			>
				<option *ngFor="let opt of field.choices" [ngValue]="opt.optionId">
					{{ opt.optionName }} {{ opt.optionDescription }}
				</option>
			</select>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectFilter implements OnInit {
	@Input() field: IHeaders;

	@Input() index: number;

	@Output() query = new EventEmitter();
	constructor() {}

	ngOnInit() {}

	changeField(event) {
		console.log(event);
		this.query.emit({field: this.field, index: this.index, contractorType: event});
	}
	// select field survey question type
	selectField(value) {
		// console.log(value.srcElement.value)
		this.field.data = value.srcElement.value;
		//  console.log(this.field)
		this.query.emit({field: this.field, index: this.index});
	}
}
